<div class="dashboard" dir="rtl">

    <!-- ===== HEADER ===== -->
    <div class="header">
        <div class="header-left">
            <div class="device-name">{{ loadWatch.strName  }}</div>
        </div>
        <div class="header-right">
            <span class="last-update">
                <i class="fa fa-clock-o"></i>
                آخرین بروزرسانی: <span>{{ (loadWatch.strServerTime | date:'HH:mm:ss - yyyy/MM/dd') }}</span>
            </span>
            <span class="status-dot" [ngClass]="loadWatch.strGeneratorStatus === 'روشن' ? 'online' : 'offline'"></span>
            <span class="status-text" [ngClass]="loadWatch.strGeneratorStatus === 'روشن' ? 'online' : 'offline'">
                {{ loadWatch.strGeneratorStatus === 'روشن' ? 'در حال کار' : 'خاموش' }}
            </span>
        </div>
    </div>

    <!-- ===== INFO SECTION ===== -->
    <div class="info-section">
        <h3><i class="fa fa-info-circle"></i> مشخصات فنی ژنراتور</h3>
        <div class="info-grid">
            <div class="info-item"><span class="label">مدل</span><span class="value">{{ loadWatch.strModel || '---' }}</span></div>
            <div class="info-item"><span class="label">برند</span><span class="value">{{ loadWatch.strBrand || '---' }}</span></div>
            <div class="info-item"><span class="label">دور ژنراتور</span><span class="value">{{ loadWatch.iEngineRPM  || '---' }}</span></div>
            <div class="info-item"><span class="label">توان نامی</span><span class="value">{{ loadWatch.fRatedPowerKW }} kW</span></div>
            <div class="info-item"><span class="label">ولتاژ نامی</span><span class="value">{{ loadWatch.iRatedVoltage }} V</span></div>
            <div class="info-item"><span class="label">تعداد استارت</span><span class="value">{{ loadWatch.iStartCount  || '---' }}</span></div>
            <div class="info-item"><span class="label">نوع سوخت</span><span class="value">{{ loadWatch.strFuelType || '---' }}</span></div>
            <div class="info-item highlight-item warning-glow">
                <span class="label">ساعت کارکرد</span>
                <span class="value">{{ loadWatch.fOperatingHours || '---' }}</span>
            </div>
            <div class="info-item highlight-item danger-glow">
                <span class="label"> سوخت مصرفی (لیتر)</span>
                <span class="value">{{ loadWatch.fFuelConsumptionTotal || '---' }}</span>
            </div>
        </div>
    </div>

    <!-- ===== KPI CARDS ===== -->
    <div class="kpi-grid">
        <div class="kpi-card power">
            <div class="kpi-value">{{ loadWatch.iActiveEnergy?.toFixed(2) || 0 }}</div>
            <div class="kpi-label"><i class="fa fa-bolt kpi-icon"></i> توان اکتیو (kW)</div>
        </div>
        <div class="kpi-card voltage">
            <div class="kpi-value">{{ loadWatch.iVoltageTotal?.toFixed(2) || 0 }}</div>
            <div class="kpi-label"><i class="fa fa-bolt kpi-icon" style="color:#ffb74d;"></i> ولتاژ (V)</div>
        </div>
        <div class="kpi-card current">
            <div class="kpi-value">{{ loadWatch.iCurrentTotal?.toFixed(2) || 0 }}</div>
            <div class="kpi-label"><i class="fa fa-flash kpi-icon" style="color:#ce93d8;"></i> جریان کل (A)</div>
        </div>
        <div class="kpi-card pf">
            <div class="kpi-value">{{ loadWatch.iPowerFactor?.toFixed(2) || 0 }}</div>
            <div class="kpi-label"><i class="fa fa-pie-chart kpi-icon" style="color:#66bb6a;"></i> ضریب توان</div>
        </div>
    </div>

    <!-- ===== MID ROW: TABLE + MAP ===== -->
    <div class="mid-row">
        <div class="table-card">
            <h3><i class="fa fa-table"></i> جزئیات سه فاز (لحظه‌ای)</h3>
            <table class="phase-table">
                <thead>
                    <tr>
                        <th>فاز</th>
                        <th>ولتاژ (V)</th>
                        <th>جریان (A)</th>
                        <th>فرکانس (Hz)</th>
                        <th>توان اکتیو(kw) </th>
                    </tr>
                </thead>
                <tbody class="text-center">
                    <tr>
                        <td class="l1"><i class="fa fa-circle" style="font-size:10px;"></i> R</td>
                        <td>{{ loadWatch.iVoltageL1?.toFixed() }}</td>
                        <td>{{ loadWatch.iCurrentL1?.toFixed() }}</td>
                        <td>{{ loadWatch.iFrequency?.toFixed(2) }}</td>
                        <td>{{ loadWatch.fActiveEnergy1?.toFixed(2) }}</td>
                    </tr>
                    <tr>
                        <td class="l2"><i class="fa fa-circle" style="font-size:10px;"></i> S</td>
                        <td>{{ loadWatch.iVoltageL2?.toFixed() }}</td>
                        <td>{{ loadWatch.iCurrentL2?.toFixed() }}</td>
                        <td>{{ loadWatch.iFrequency?.toFixed(2) }}</td>
                        <td>{{ loadWatch.fActiveEnergy2?.toFixed(2) }}</td>
                    </tr>
                    <tr>
                        <td class="l3"><i class="fa fa-circle" style="font-size:10px;"></i> T</td>
                        <td>{{ loadWatch.iVoltageL3?.toFixed() }}</td>
                        <td>{{ loadWatch.iCurrentL3?.toFixed() }}</td>
                        <td>{{ loadWatch.iFrequency?.toFixed(2) }}</td>
                        <td>{{ loadWatch.fActiveEnergy3?.toFixed(2) }}</td>
                    </tr>
                </tbody>
            </table>
            <div style="margin-top:12px; font-size:13px; color:#78909c; text-align:center;">
                <i class="fa fa-clock-o"></i> زمان اطلاعات: <span class="en-number"> {{ loadWatch.strFixDate | date:'HH:mm:ss' }}</span>
            </div>
        </div>

        <div class="map-card">
            <h3><i class="fa fa-map"></i> موقعیت دستگاه</h3>
            <div id="generator-map"></div>
            <div style="margin-top:10px; font-size:12px; color:#78909c; text-align:center;">
                <i class="fa fa-globe"></i> ماهواره: <span>{{ loadWatch.tiSatellites }}</span> &nbsp;|&nbsp;
                <i class="fa fa-compass"></i> زاویه: <span>{{ loadWatch.iAngel }}</span>° &nbsp;|&nbsp;
                <i class="fa fa-tachometer"></i> سرعت: <span>{{ loadWatch.iSpeed }}</span>
            </div>
        </div>
    </div>

    <!-- ===== INDICATORS SECTION ===== -->
    <div class="indicators-section">
        <h3><i class="fa fa-heartbeat"></i> شاخص‌های عملکرد و سلامت</h3>
        <div class="indicators-grid">
            
            <div class="indicator-card">
                <div class="ind-header">
                    <span class="ind-label">
                        عدم تعادل جریان
                        <small>({{ getImbalanceStatus(loadWatch.iCurrentUnbalance) }})</small>
                    </span>
                    <span class="ind-value">{{ loadWatch.iCurrentUnbalance || 0 }}%</span>
                </div>
                <div class="ind-track"><div class="ind-fill" [style.width.%]="loadWatch.iCurrentUnbalance || 0" style="background: #ce93d8;"></div></div>
            </div>

            <div class="indicator-card">
                <div class="ind-header">
                    <span class="ind-label">
                        عدم تعادل ولتاژ
                        <small>({{ getImbalanceStatus(loadWatch.iVoltageUnbalance) }})</small>
                    </span>
                    <span class="ind-value">{{ loadWatch.iVoltageUnbalance || 0 }}%</span>
                </div>
                <div class="ind-track"><div class="ind-fill" [style.width.%]="loadWatch.iVoltageUnbalance || 0" style="background: #ffb74d;"></div></div>
            </div>

            <div class="indicator-card">
                <div class="ind-header">
                    <span class="ind-label">
                        عدم تعادل توان
                        <small>({{ getImbalanceStatus(loadWatch.iPowerUnbalance) }})</small>
                    </span>
                    <span class="ind-value">{{ loadWatch.iPowerUnbalance || 0 }}%</span>
                </div>
                <div class="ind-track"><div class="ind-fill" [style.width.%]="loadWatch.iPowerUnbalance || 0" style="background: #ef5350;"></div></div>
            </div>

            <div class="indicator-card">
                <div class="ind-header">
                    <span class="ind-label">راندمان ژنراتور</span>
                    <span class="ind-value">{{ loadWatch.iGeneratorEfficiency || 0 }}%</span>
                </div>
                <div class="ind-track"><div class="ind-fill" [style.width.%]="loadWatch.iGeneratorEfficiency || 0" style="background: #66bb6a;"></div></div>
            </div>

            <div class="indicator-card">
                <div class="ind-header">
                    <span class="ind-label">سلامت فازها</span>
                    <span class="ind-value">{{ loadWatch.iPhaseHealthScore || 0 }}%</span>
                </div>
                <div class="ind-track"><div class="ind-fill" [style.width.%]="loadWatch.iPhaseHealthScore || 0" style="background: #4fc3f7;"></div></div>
            </div>

            <div class="indicator-card">
                <div class="ind-header">
                    <span class="ind-label">سلامت سیستم برق</span>
                    <span class="ind-value">{{ loadWatch.iElectricalHealthScore || 0 }}%</span>
                </div>
                <div class="ind-track"><div class="ind-fill" [style.width.%]="loadWatch.iElectricalHealthScore || 0" style="background: #4db6ac;"></div></div>
            </div>

            <div class="indicator-card">
                <div class="ind-header">
                    <span class="ind-label">بار ژنراتور</span>
                    <span class="ind-value">{{ loadWatch.iGeneratorLoading || 0 }}%</span>
                </div>
                <div class="ind-track"><div class="ind-fill" [style.width.%]="loadWatch.iGeneratorLoading || 0" style="background: #ffa726;"></div></div>
            </div>

            <div class="indicator-card">
                <div class="ind-header">
                    <span class="ind-label">دمای آب (Coolant)</span>
                    <span class="ind-value">{{ loadWatch.iCoolantTemperature || 0 }} °C</span>
                </div>
                <div class="ind-track"><div class="ind-fill" [style.width.%]="loadWatch.iCoolantTemperature || 0" style="background: #29b6f6;"></div></div>
            </div>

            <div class="indicator-card">
                <div class="ind-header">
                    <span class="ind-label">دمای روغن</span>
                    <span class="ind-value">{{ loadWatch.iOilTemperature || 0 }} °C</span>
                </div>
                <div class="ind-track"><div class="ind-fill" [style.width.%]="loadWatch.iOilTemperature || 0" style="background: #fbc02d;"></div></div>
            </div>

        </div>
    </div>

    <!-- ===== POWER ROW ===== -->
    <div class="power-row">
        <div class="power-item">
            <div class="label"><i class="fa fa-bolt" style="color:#4fc3f7;"></i> توان ظاهری</div>
            <div class="value">{{ loadWatch.iAparentEnergy?.toFixed() || 0 }} <span class="unit">kVA</span></div>
        </div>
        <div class="power-item">
            <div class="label"><i class="fa fa-bolt" style="color:#66bb6a;"></i> توان اکتیو</div>
            <div class="value">{{ loadWatch.iActiveEnergy?.toFixed() || 0 }} <span class="unit">kW</span></div>
        </div>
        <div class="power-item">
            <div class="label"><i class="fa fa-bolt" style="color:#ffa726;"></i> توان راکتیو</div>
            <div class="value">{{ loadWatch.iReactivePower?.toFixed() || 0 }} <span class="unit">kVAR</span></div>
        </div>
        <div class="load-bar-card">
            <div class="label">درصد بار لحظه‌ای</div>
            <div class="load-value">{{ loadWatch.tiLoadPercentage?.toFixed() }}%</div>
            <div class="load-track">
                <div class="load-fill" [style.width.%]="loadWatch.tiLoadPercentage?.toFixed()"></div>
            </div>
        </div>
    </div>

    <!-- ===== LOCATION ROW ===== -->
    <div class="location-row">
        <div><i class="fa fa-map-pin"></i> عرض جغرافیایی: <span class="highlight">{{ loadWatch.fLat }}</span></div>
        <div><i class="fa fa-map-pin"></i> طول جغرافیایی: <span class="highlight">{{ loadWatch.fLon }}</span></div>
        <div><i class="fa fa-level-up"></i> ارتفاع: <span class="highlight">{{ loadWatch.iAltitude }}</span> متر</div>
    </div>

    <!-- ===== FOOTER ===== -->
    <div style="margin-top: 20px; text-align: center; font-size: 12px; color: #37474f; border-top: 1px solid #1e293b; padding-top: 16px;">
        LoadWatch · داده‌های لحظه‌ای · IMEI: <span>{{ loadWatch.strIMEI }}</span>
    </div>

</div>
